import script from "./AvailableBranches.vue?vue&type=script&setup=true&lang=js"
export * from "./AvailableBranches.vue?vue&type=script&setup=true&lang=js"

import "./AvailableBranches.vue?vue&type=style&index=0&id=e98781d0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e98781d0"]])

export default __exports__